import React from 'react'
import { ClockingRules } from '../../api/clocking-rules'
import locales from '../../../../locales'
import { toleranceInMillisecondsToMinutes } from '../../utils/clocking-rules'

interface ClockingRulesDescriptionProps {
  clockingRules: ClockingRules
  type: 'start' | 'end'
  small?: boolean
}

const ClockingRulesDescription: React.FC<ClockingRulesDescriptionProps> = ({
  clockingRules,
  type,
  small,
}) => {
  return (
    <ul style={{ whiteSpace: 'nowrap' }}>
      <li>
        {small ? 'En avance' : 'Je suis en avance, on prend en compte :'}{' '}
        <b>{locales.clockings[clockingRules.rules[type].early.mode]}</b>
        <br />
        {clockingRules.rules[type].early.tolerance !== 0 && (
          <>
            ⤷ {small ? 'Tolérance' : 'Sauf si avance de moins de'}{' '}
            <b>{toleranceInMillisecondsToMinutes(clockingRules.rules[type].early.tolerance)} min</b>
          </>
        )}
      </li>
      <li>
        {small ? 'En retard' : 'Je suis en retard, on prend en compte :'}{' '}
        <b>{locales.clockings[clockingRules.rules[type].late.mode]}</b>
        <br />
        {clockingRules.rules[type].late.tolerance !== 0 && (
          <>
            ⤷ {small ? 'Tolérance' : 'Sauf si retard de moins de'}{' '}
            <b>{toleranceInMillisecondsToMinutes(clockingRules.rules[type].late.tolerance)} min</b>
          </>
        )}
      </li>
    </ul>
  )
}

export default ClockingRulesDescription
